import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import CopyEndEnhancer from '@/shared/components/SDComponentsNewDesign/CopyEndEnhancer/CopyEndEnhancer'
import useFiscalCode from './useFiscalCode'

interface FiscalCodeProps {
  missing?: boolean
}

const FiscalCode = ({ missing = false }: FiscalCodeProps) => {
  const { taxIdCode, label, error, isEditable, status, onBlur, hidden } = useFiscalCode()

  if (hidden) {
    return null
  }

  return (
    <SDFormControl error={error}>
      <SDInput
        id='input-customer-tax-id-code'
        label={label}
        currentValue={taxIdCode}
        disabled={isEditable === false}
        error={!!error}
        overrides={undefined}
        status={status}
        missing={missing}
        endEnhancer={<CopyEndEnhancer value={taxIdCode} />}
        outerOnchange={undefined}
        onBlur={onBlur}
      />
    </SDFormControl>
  )
}

export default FiscalCode
